export default "__VITE_ASSET__BZgAFm86__"